import {
  GROUPS_START,
  GET_GROUPS_SUCCESS,
  GROUPS_FAIL,
  GROUPS_DELETE_SUCCESS,
  ADD_NEW_GROUP_SUCCESS,
  EDIT_GROUP,
  SAVE_GROUP_FILTER,
  SELECTED_GROUP,
  EMPTY_GROUPS,
} from "./constants";

const initialState = {
  groups: [],
  selectedGroup: {},
  filter: {},
  success: false,
  loading: false,
  error: {
    type: "",
    message: "",
  },
};

const groupsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GROUPS_START:
      return { ...state, loading: true, error: { ...initialState.error }, success: false };
    case ADD_NEW_GROUP_SUCCESS: {
      // To order groups from new to old
      const newGroupItem = action.groupToRender;
      const oldGroups = [...state.groups];
      oldGroups.unshift(newGroupItem);
      return {
        ...state,
        selectedGroup: {},
        loading: false,
        error: { type: "", message: "" },
        // groups: oldGroups,
        groups: [...new Map(oldGroups.map((item) => [item["_id"], item])).values()],
      };
    }
    case GET_GROUPS_SUCCESS:
      return { ...state, loading: false, groups: payload };
    case GROUPS_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedGroup: {},
        groups: state.groups.filter((group) => group._id !== payload._id),
        success: true,
      };
    case GROUPS_FAIL:
      return { ...state, loading: false, error: { ...payload }, success: false, selectedGroup: {} };
    case EDIT_GROUP:
      return {
        ...state,
        loading: false,
        selectedGroup: {},
        error: { type: "", message: "" },
        // we need this code if the response updated
        // groups: [
        //   ...state.groups.map(group =>
        //     group._id === action.groupToRender._id
        //       ? {
        //           ...action.groupToRender,
        //           selectedContacts: action.groupToRender.selectedContacts.map(_id => ({ _id }))
        //         }
        //       : group
        //   )
        // ]
        groups: [
          ...state.groups.map((group) =>
            group._id === action.groupToRender._id ? action.groupToRender : group,
          ),
        ],
      };
    case SAVE_GROUP_FILTER:
      return { ...state, filter: action.filter };
    case SELECTED_GROUP:
      return { ...state, selectedGroup: action.selectedGroup };
    case EMPTY_GROUPS:
      return { ...state, groups: [], selectedGroup: {} };
    default:
      return state;
  }
};

export default groupsReducer;
